import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const ChevronLeft = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 12 22">
      <path d="M10.304,0.615l-10.036,9.722c-0.368,0.387 -0.356,0.983 0.025,1.351l10.037,9.721c0.396,0.353 1,0.342 1.377,-0.024l0.097,-0.11c0.291,-0.385 0.256,-0.923 -0.097,-1.265l-9.302,-9.01l9.326,-9.034c0.368,-0.387 0.356,-0.982 -0.024,-1.35c-0.388,-0.377 -1.015,-0.377 -1.403,0l0,-0.001Z" />
    </svg>
  );
};

ChevronLeft.defaultProps = {
  width: '100%',
  height: '100%',
};

export default ChevronLeft;
